import {StockInformationModel} from "../domain/stockInformationModel";

type ProductStatusModelType = Pick<
    StockInformationModel,
    | "status"
    | "isNewProduct"
>;

export class ProductStatusModel {
    private _model: ProductStatusModelType;

    constructor(model: ProductStatusModelType) {
        this._model = model;
    }

    get status() {
        return this._model.status;
    }

    get isNewProduct() {
        return this._model.isNewProduct;
    }

    static create(model: StockInformationModel) {
        return new ProductStatusModel(model);
    }
}
